import type { ForwardedRef } from 'react';
import { forwardRef, useState } from 'react';

import type { InputFieldProps } from 'components/ui/molecules/InputField';
import { InputField } from 'components/ui/molecules/InputField';

export const PasswordField = forwardRef<HTMLInputElement, InputFieldProps>(
  (props, ref: ForwardedRef<HTMLInputElement>) => {
    const [show, setShow] = useState<boolean>(false);
    const { children, ...inputProps } = props;
    return (
      <InputField {...inputProps} type={show ? 'text' : 'password'} ref={ref}>
        {children ? (
          children
        ) : (
          <a
            className="absolute right-4 cursor-pointer align-middle text-sm font-medium leading-12 text-feedback-info hover:text-content-brand"
            onClick={() => setShow(!show)}
          >
            {show ? 'Hide' : 'Show'}
          </a>
        )}
      </InputField>
    );
  }
);
PasswordField.displayName = 'PasswordField';
